import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setPageTitle } from 'actions/header';
import { getUnreadNotifications } from 'actions/notifications';
import { Icon, translate, ActionSheet, getActiveLanguage } from '@haldor/ui';
import { languages, getLanguage, setLanguage } from './LanguageManager';
import './_page.scss';
var MenuPage = /*#__PURE__*/function (_Component) {
  function MenuPage(props) {
    var _this;
    _classCallCheck(this, MenuPage);
    _this = _callSuper(this, MenuPage, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var menuPageTitle = document.querySelector("#menu-page-title");
      var pageTitle = document.querySelector("#page-title");
      if (menuPageTitle && pageTitle) {
        pageTitle.style.display = "none";
        menuPageTitle.innerHTML = _this.props.translate('Menu');
      }
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      var menuPageTitle = document.querySelector("#menu-page-title");
      var pageTitle = document.querySelector("#page-title");
      if (menuPageTitle && pageTitle) {
        menuPageTitle.innerHTML = "";
        pageTitle.style.display = "block";
      }
    });
    _defineProperty(_this, "getBadgeForItem", function (item) {
      if (_this.props.unreadNotifications != null) {
        if (item.url == '/conversations') {
          if (_this.props.unreadNotifications.conversations != null && parseInt(_this.props.unreadNotifications.conversations) > 0) {
            return _this.props.unreadNotifications.conversations;
          }
        }
        if (item.url == '/notifications') {
          if (_this.props.unreadNotifications.events != null && parseInt(_this.props.unreadNotifications.events) > 0) {
            return _this.props.unreadNotifications.events;
          }
        }
        if (item.url == '/posts') {
          if (_this.props.unreadNotifications.posts != null && parseInt(_this.props.unreadNotifications.posts) > 0 || _this.props.unreadNotifications.documentations != null && parseInt(_this.props.unreadNotifications.documentations) > 0) {
            var _this$props$unreadNot, _this$props$unreadNot2;
            return ((_this$props$unreadNot = _this.props.unreadNotifications.posts) !== null && _this$props$unreadNot !== void 0 ? _this$props$unreadNot : 0) + ((_this$props$unreadNot2 = _this.props.unreadNotifications.documentations) !== null && _this$props$unreadNot2 !== void 0 ? _this$props$unreadNot2 : 0);
          }
        }
      }
      return null;
    });
    _defineProperty(_this, "linkTexts", function (value) {
      switch (value) {
        case "NAV_HOME":
          return _this.props.translate('Home');
          break;
        case "NAV_SCHEDULE":
          return _this.props.translate('Schedule');
          break;
        case "NAV_POSTS":
          return _this.props.translate('Posts');
          break;
        case "NAV_ASSIGNMENTS":
          return _this.props.translate('Assignments');
          break;
        case "NAV_PLANS":
          return _this.props.translate('Plans');
          break;
        case "NAV_MESSAGES":
          return _this.props.translate('Messages');
          break;
        case "NAV_NOTIFICATIONS":
          return _this.props.translate('Events');
          break;
        case "NAV_FORMS":
          return _this.props.translate('Forms');
          break;
        case "NAV_MEETINGS":
          return _this.props.translate('Parent-teacher meeting');
          break;
        case "NAV_ABSENCE":
          return _this.props.translate('Absence');
          break;
        case "NAV_ATTENDANCE":
          return _this.props.translate('Attendance');
          break;
        case "NAV_COURSES":
          return _this.props.translate('Courses');
          break;
        case "NAV_GROUPS":
          return _this.props.translate('Groups');
          break;
        case "NAV_ABSENCE":
          return _this.props.translate('Absence');
          break;
        case "NAV_PROGRESS":
          return _this.props.translate('Progress');
          break;
        default:
          return value;
          break;
      }
    });
    _defineProperty(_this, "categoryText", function (value) {
      switch (value) {
        case "EDUCATION":
          return _this.props.translate('Education');
          break;
        case "MENTOR":
          return _this.props.translate('Mentor');
          break;
        case "ADMINISTRATION":
          return _this.props.translate('Administration');
          break;
        default:
          return value;
          break;
      }
    });
    _defineProperty(_this, "onExternalClick", function (ev) {
      if (window.ReactNativeWebView != null) {
        ev.preventDefault();
        var link = ev.target.closest('a');
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'OPEN_URL',
          external_url_open: link.getAttribute('href')
        }));
      }
    });
    _defineProperty(_this, "confirmLogOut", function () {
      var menuItems = [];
      var translate = _this.props.translate;
      var items = [{
        label: translate('Yes'),
        link: '/logout',
        background: "#73d266"
      }, {
        label: translate('No'),
        link: '#',
        background: "#E6E6E6"
      }];
      items.forEach(function (item) {
        menuItems.push({
          label: item.label == translate("Yes") ? /*#__PURE__*/React.createElement("div", {
            key: 'item-yes'
          }, /*#__PURE__*/React.createElement("h3", {
            style: {
              marginBottom: "25px"
            }
          }, translate('verify_logout')), /*#__PURE__*/React.createElement("a", {
            style: {
              textTransform: "uppercase",
              textDecoration: "none",
              color: "white",
              display: "inline-flex",
              justifyContent: "center",
              backgroundColor: item.background,
              width: "100%",
              padding: "10px",
              borderRadius: "10px",
              fontWeight: "bold"
            },
            href: item.link
          }, item.label)) : /*#__PURE__*/React.createElement("div", {
            key: 'item-no'
          }, /*#__PURE__*/React.createElement("a", {
            style: {
              textTransform: "uppercase",
              textDecoration: "none",
              color: "black",
              display: "inline-flex",
              justifyContent: "center",
              backgroundColor: item.background,
              width: "100%",
              padding: "10px",
              borderRadius: "10px"
            },
            href: item.link
          }, item.label))
        });
      });
      ActionSheet.prompt({
        items: menuItems
      }).then(function (selection) {}, function () {
        // This method only runs if user closes the prompt without pressing an option
      });
    });
    _defineProperty(_this, "selectLanguage", function () {
      var languageMenu = [];
      languages().forEach(function (language, index) {
        languageMenu.push({
          label: getActiveLanguage().toLowerCase() == language.lcid.toLowerCase() ? /*#__PURE__*/React.createElement("div", {
            style: {
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between"
            },
            key: 'language-' + index
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              display: "flex",
              alignItems: "center"
            }
          }, /*#__PURE__*/React.createElement("img", {
            style: {
              height: "16px",
              width: "22px",
              objectFit: "cover",
              marginRight: "10px",
              borderRadius: "2px"
            },
            alt: language.label,
            src: language.svg_src
          }), " ", language.label), /*#__PURE__*/React.createElement(Icon, {
            name: "check"
          })) : /*#__PURE__*/React.createElement("span", {
            key: 'language-' + index,
            onClick: function onClick() {
              return setLanguage(language.lcid, _this.props.profile);
            },
            style: {
              display: "flex",
              alignItems: "center"
            }
          }, /*#__PURE__*/React.createElement("img", {
            style: {
              height: "16px",
              width: "22px",
              objectFit: "cover",
              marginRight: "10px",
              borderRadius: "2px"
            },
            alt: language.label,
            src: language.svg_src
          }), " ", language.label)
        });
      });
      ActionSheet.prompt({
        items: languageMenu
      }).then(function (selection) {}, function () {
        // This method only runs if user closes the prompt without pressing an option
      });
    });
    _this.blocked = ['NAV_HOME', 'NAV_PLANS', 'NAV_SCHEDULE'];
    return _this;
  }
  _inherits(MenuPage, _Component);
  return _createClass(MenuPage, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var categories = [];
      var profile = this.props.profile;
      var displayActiveLanguage = getLanguage();
      if (this.props.items != null) {
        this.props.items.forEach(function (item) {
          if (item.parentId != null && item.parentId != '') {
            if (categories.indexOf(item.parentId) == -1) {
              categories.push(item.parentId);
            }
          }
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "menu-page"
      }, /*#__PURE__*/React.createElement("div", {
        className: "items-container"
      }, this.props.items != null ? this.props.items.map(function (item, index) {
        if (_this2.blocked.indexOf(item.text) > -1) {
          return null;
        }
        if (item.parentId != null && item.parentId != '') {
          return null;
        }
        if (item.type == 'EXTERNAL') {
          return null;
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "menu-item-container",
          key: 'item-' + index
        }, /*#__PURE__*/React.createElement(Link, {
          onClick: _this2.props.onClose,
          to: item.url,
          activeClassName: "is-active",
          className: "menu-item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "menu-item-icon"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: item.iconId
        }), _this2.getBadgeForItem(item) != null ? /*#__PURE__*/React.createElement("div", {
          className: "badge"
        }, /*#__PURE__*/React.createElement("span", null, _this2.getBadgeForItem(item))) : null), /*#__PURE__*/React.createElement("span", null, _this2.linkTexts(item.text.toUpperCase()))));
      }) : null, categories.map(function (category, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "menu-divider",
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "divider-label"
        }, _this2.categoryText(category.toUpperCase())), /*#__PURE__*/React.createElement("div", {
          className: "items"
        }, _this2.props.items.map(function (item, index) {
          if (_this2.blocked.indexOf(item.text) > -1) {
            return null;
          }
          if (item.parentId != null && item.parentId == category) {
            return /*#__PURE__*/React.createElement("div", {
              className: "menu-item-container",
              key: 'item-' + index
            }, /*#__PURE__*/React.createElement(Link, {
              onClick: _this2.props.onClose,
              to: item.url,
              activeClassName: "is-active",
              className: "menu-item"
            }, /*#__PURE__*/React.createElement("div", {
              className: "menu-item-icon"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: item.iconId
            })), /*#__PURE__*/React.createElement("span", null, _this2.linkTexts(item.text.toUpperCase()))));
          }
        })));
      }), this.props.items != null ? this.props.items.map(function (item, index) {
        if (item.parentId != null && item.parentId != '') {
          return null;
        }
        if (item.type != 'EXTERNAL') {
          return null;
        }
        var label = item.text;
        if (label.indexOf('nav_') > -1) {
          label = _this2.linkTexts(item.text.toUpperCase());
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "menu-item-container",
          key: 'item-' + index
        }, /*#__PURE__*/React.createElement("a", {
          href: item.url,
          onClick: function onClick(e) {
            return _this2.onExternalClick(e);
          },
          target: "_blank",
          className: "menu-item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "menu-item-icon"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: item.iconId
        })), /*#__PURE__*/React.createElement("span", null, label)));
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container",
        key: 'help'
      }, /*#__PURE__*/React.createElement("a", {
        className: "menu-item",
        target: "_blank",
        onClick: function onClick(e) {
          return _this2.onExternalClick(e);
        },
        href: "https://startvh.haldor.se"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon",
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          width: "24px"
        },
        src: "/dist/img/help-ico.png",
        alt: "support-icon"
      })), /*#__PURE__*/React.createElement("span", null, this.props.translate('Help center')))), /*#__PURE__*/React.createElement("div", {
        className: "menu-divider"
      }, /*#__PURE__*/React.createElement("div", {
        className: "divider-label"
      }, this.categoryText(this.props.translate("Settings"))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container",
        key: 'profile'
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: this.props.onClose,
        to: "/profile",
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Cog"
      })), /*#__PURE__*/React.createElement("span", null, this.props.translate('Your information')))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container",
        key: 'languages'
      }, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.selectLanguage,
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon",
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("img", {
        className: "flag",
        alt: displayActiveLanguage.label,
        src: displayActiveLanguage.svg_src
      })), /*#__PURE__*/React.createElement("span", null, displayActiveLanguage.label, " ", /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron_Down",
        style: {
          marginLeft: "5px"
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "menu-item-container",
        key: 'logout-confirm'
      }, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.confirmLogOut,
        className: "menu-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu-item-icon"
      }, /*#__PURE__*/React.createElement("img", {
        className: "person",
        src: "/dist/svg/person.svg",
        alt: "person"
      })), profile != null ? /*#__PURE__*/React.createElement("span", null, this.props.translate('Sign out'), " ", profile.firstName + (profile.lastName != null ? ' ' + profile.lastName : '')) : /*#__PURE__*/React.createElement("span", null, this.props.translate('Sign out')))))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    items: state.Menu.items,
    translate: translate(state.Languages.translations),
    student: state.User.activeStudent,
    unreadNotifications: state.Notifications.unreadNotifications,
    profile: state.profile.profile,
    pathname: document.location.pathname
  };
}
export default connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  getUnreadNotifications: getUnreadNotifications
})(MenuPage);